module.exports = __webpack_public_path__ + "static/media/neosoft.cf577bee.jpeg";